// Dependency-free so it can run in the native staff app as well as the server.

/**
 * Format a Date as YYYY-MM-DD in the given timezone.
 * Uses formatToParts for locale-independent formatting.
 */
export function toDateInTz(date: Date, tz: string): string {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  const parts = formatter.formatToParts(date)
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find(p => p.type === type)?.value || '00'
  return `${get('year')}-${get('month')}-${get('day')}`
}
